import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-295" data-mp="29l6mz0jzd5cp">
      <SEO title="About | KittyPot — No More Chasing Friends for Money" description="The story behind KittyPot, a shared expense and settlement tracker that helps groups track shared expenses, split costs fairly, and see the simplest way to settle up." ogTitle="About KittyPot" ogDescription="Track shared expenses, split costs fairly, and see the simplest way to settle up." path="/about" data-id="element-296" data-mp="2egm2dwxmz9b8" />
      <Navbar data-id="element-297" data-mp="2x7d9eru5inmg" />
      <main className="pt-32 pb-24" data-id="element-298" data-mp="2xb13bs3idc1p">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-299" data-mp="1guone9igtm41">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-300" data-mp="1lu1a8u9c6t6m">
            About KittyPot
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-301" data-mp="1uhicn90gca30">
            <p data-id="element-302" data-mp="1ujmpwhk8qlfy">
              KittyPot started with a simple question: how do groups keep things
              fair when one person pays and everyone else needs to settle up?
            </p>
            <p data-id="element-303" data-mp="23gdkepj59s8f">
              The idea was sparked during the pandemic, during a family
              conversation about organising a kitty for a bike tour. With
              contactless replacing cash, group money was becoming increasingly
              awkward to manage.
            </p>
            <p data-id="element-304" data-mp="28hb3d4bzaqaz">
              KittyPot was built to make shared expenses clearer, fairer and
              easier to settle — so groups can enjoy the moment together.
            </p>
            <p data-id="element-305" data-mp="2i7w8zbq2kv3e">
              KittyPot brings shared expenses, fair splits and clear settlement
              tracking together in one simple place.
            </p>
            <p className="font-medium mt-8" data-id="element-306" data-mp="2r8kjvxk62fc2">Benjamin Elliott, Founder</p>
          </div>
        </div>
      </main>
      <Footer data-id="element-307" data-mp="1ovo3w82sip82" />
    </div>;
}